import { render } from "./exclusive.vue?vue&type=template&id=20eb3ba0"
import script from "./exclusive.vue?vue&type=script&lang=js"
export * from "./exclusive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__